import { render, staticRenderFns } from "./loyaltySmartMoments.vue?vue&type=template&id=48218414&"
import script from "./loyaltySmartMoments.vue?vue&type=script&lang=js&"
export * from "./loyaltySmartMoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports